import { h, Host } from "@stencil/core";
export class ListItem {
    render() {
        return (h(Host, { key: 'f03aa222fa4235624fcd18d3035188825efa0cc7' }, h("li", { key: 'b14061d7a2aaa9c87992b542c828649564cb3ae2' }, h("slot", { key: '8cb69d7cac78ceee816a63fd22eb133a4fccf920' }))));
    }
    static get is() { return "ux-list-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["list-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["list-item.css"]
        };
    }
}
//# sourceMappingURL=list-item.js.map
